import React from "react";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useNavigate } from "react-router-dom";

const MeetCard = ({ meetDetailObj }) => {
  const cardImage = require("./../assets/images/meetCardImage.jfif");
  const navigate = useNavigate();

  const secToDate = (sec) =>
    new Date(sec * 1000).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  return (
    <div className="meetCardMainDiv">
      <div
        className="meetCardImageDiv"
        style={{
          backgroundImage: `url(${cardImage})`,
          backgroundSize: "cover",
        }}
      >
        <div className="heartIconDiv">
          <FavoriteBorderIcon className="heartIcon" />
        </div>
      </div>
      <div className="meetCardDetailDiv">
        <div className="meetCardDetaiNameDiv">
          <div>
            <span className="meetName">
              {meetDetailObj.name || "MEET NAME HERE"}
            </span>
            <br />
            <span className="cardDisciplines">{meetDetailObj.disciplines}</span>
          </div>
          <div className="hashDiv">
            <span className="hashText">#</span>
          </div>
        </div>
        <div className="meetCardDetaiDateDiv">
          <div>
            <span className="meetDate">
              {secToDate(meetDetailObj.startDate.seconds) || "DATE HERE"}
            </span>
          </div>
          <div>
            <button
              className="MeetCardViewBtn"
              onClick={() => navigate(`Meet/${meetDetailObj.id}`)}
            >
              VIEW
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetCard;
